<form #form="ngForm" class="form-horizontal" (ngSubmit)="form.valid && submit()">
    <div class="mon-dialog-header">
        <page-header header="{{'API User' | translate}}"></page-header>
    </div>
    <div class="mon-dialog-body-with-footer">
        <div class="card panel-monsido-card mt-3 mx-3">
            <div class="card-header">
                <h2 class="font-weight-300" translate>
                    API User Details
                </h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="offset-sm-8 col-sm-40">
                        <div class="form-check form-check-inline" *ngFor="let scope of scopes; let i = index; trackBy: trackByIndex">
                            <input class="form-check-input"
                                   type="checkbox"
                                   [attr.id]="'api_user_scope_' + i"
                                   [checked]="isScopeChecked(scope.value)"
                                   (click)="setScope(scope.value)"
                                   [attr.name]="'api_user_scope_' + i">
                            <label class="form-check-label" [attr.for]="'api_user_scope_' + i">{{scope.name}}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row my-1">
                    <label class="col-sm-8 col-form-label text-bold capitalize-first-letter text-right"
                           for="api_user_description"
                           translate>
                        Description*
                    </label>
                    <div class="col-sm-40">
                        <textarea [(ngModel)]="ngModel.description"
                                  [required]="true"
                                  id="api_user_description"
                                  name="description"
                                  class="form-control"
                                  rows="6"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button data-test="save-button"
                class="btn btn-border-radius btn-secondary"
                [disabled]="saving || form.invalid"
                type="submit">
            <span *ngIf="!saving" translate>Save</span>
            <span *ngIf="saving"
                  class="fa-spin fa-fw"
                  [ngClass]="['SPINNER', 'ICON'] | monIcons"
                  aria-hidden="true">
            </span>
        </button>
    </div>
</form>
